import "./App.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import AppRoutes from "./routes";

import { UploadProvider } from "./contexts/UploadContext";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <UploadProvider>
          <AppRoutes />
        </UploadProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
